export const colors = {
  primary: 'purple.500',
  accent: '#01DE95',
};
